define.alias("shared/components/shared/ui/checkbox-switch", "settings/components/shared/ui/checkbox-switch");